module.exports = __webpack_public_path__ + "media/images/search-icon-46166a60.png";